import BaseModel from './BaseModel'
import Event from './Event'
import { EventTier } from './EventTier'
import { Inventory } from './Inventory'
import { VenueLocationProduct } from './VenueLocationProduct'
import VenueTier from './VenueTier'

/**
 * @todo Add types for API methods.
 */
export default class EventInventoryTier extends BaseModel {

  static entity = 'event_inventory_tiers'
  static primaryKey = 'ID'

  declare ID: number
  declare inventoryID: number
  declare eventID: number
  declare venueLocationProductID: number
  declare currentVenueTierID: number | null
  declare currentEventTierID: number | null
  declare inventory: Inventory
  declare event: Event
  declare venueLocationProduct: VenueLocationProduct
  declare currentVenueTier: VenueTier
  declare currentEventTier: EventTier

  static fields() {

    return {

      // fields
      ID: this.number(null),
      inventoryID: this.number(null),
      eventID: this.number(null),
      venueLocationProductID: this.number(null),
      currentVenueTierID: this.number(null).nullable(),
      currentEventTierID: this.number(null).nullable(),

      // relationships
      inventory: this.belongsTo(Inventory, 'inventoryID'),
      event: this.belongsTo(Event, 'eventID'),
      venueLocationProduct: this.belongsTo(VenueLocationProduct, 'venueLocationProductID'),
      currentVenueTier: this.belongsTo(VenueTier, 'currentVenueTierID'),
      currentEventTier: this.belongsTo(EventTier, 'currentEventTierID'),

    }

  }

}
